export const CELL = {
	AVAILABLE: 'available',
	BOOKED: 'booked',
	CHOOSED: 'choosed',
	DISABLED: 'disabled',
	NONE: 'none',
};



// WEBPACK FOOTER //
// ./src/enums/index.js